import translate from './translate';

export { translate };
export { thousandsSeparator } from './thousandSeperator';
export { detectIE } from './detect-ie';
export { componentDidMount, componentDidUpdate, componentWillUnmount } from './hooks';
export { parseURL } from './parse-url';
export { fileLink } from './file-link';
export { genreHeb } from './translate-genre';
export { createXlsx } from './create-xls';
export { scrollToInputError } from './scroll-to-input-error';
export const sleep = ms => new Promise(res => setTimeout(res, ms));
